export default "__VITE_ASSET__CMWNxaBf__"